import { supabase, getCurrentUserId } from './supabase';

export type PricingConfig = {
  base_fee: number;
  soket_e_fee: number;
  soket_h_fee: number;
  greft_e_fee: number;
  greft_h_fee: number;
  kemik_1_fee: number;
  kemik_2_fee: number;
  kemik_3_fee: number;
  hacim_z_fee: number;
  hacim_y_fee: number;
  healing_e_fee: number;
  healing_h_fee: number;
  currency: string;
  updated_at: string;
};

export const DEFAULT_PRICING: PricingConfig = {
  base_fee: 15000,
  soket_e_fee: 2000,
  soket_h_fee: 0,
  greft_e_fee: 3500,
  greft_h_fee: 0,
  kemik_1_fee: 0,
  kemik_2_fee: 1000,
  kemik_3_fee: 2500,
  hacim_z_fee: 0,
  hacim_y_fee: 1500,
  healing_e_fee: 1000,
  healing_h_fee: 0,
  currency: '₺',
  updated_at: new Date().toISOString(),
};

let _cache: PricingConfig = { ...DEFAULT_PRICING };

export const pricingDB = {
  get: (): PricingConfig => _cache,

  load: async (): Promise<PricingConfig> => {
    try {
      const userId = await getCurrentUserId();
      const { data, error } = await supabase
        .from('user_pricing_config')
        .select('config')
        .eq('user_id', userId)
        .maybeSingle();
      if (!error && data?.config) {
        _cache = { ...DEFAULT_PRICING, ...(data.config as Partial<PricingConfig>) };
      }
    } catch {
      // unauthenticated or network error — keep default
    }
    return _cache;
  },

  save: async (config: Omit<PricingConfig, 'updated_at'>): Promise<PricingConfig> => {
    const userId = await getCurrentUserId();
    const updated: PricingConfig = { ...config, updated_at: new Date().toISOString() };
    const { error } = await supabase
      .from('user_pricing_config')
      .upsert({ user_id: userId, config: updated, updated_at: updated.updated_at });
    if (error) throw error;
    _cache = updated;
    return updated;
  },

  reset: async (): Promise<PricingConfig> => {
    const userId = await getCurrentUserId();
    const resetConfig: PricingConfig = { ...DEFAULT_PRICING, updated_at: new Date().toISOString() };
    const { error } = await supabase
      .from('user_pricing_config')
      .upsert({ user_id: userId, config: resetConfig, updated_at: resetConfig.updated_at });
    if (error) throw error;
    _cache = resetConfig;
    return resetConfig;
  },

  calcToothFee: (
    config: PricingConfig,
    tooth: { soket: string; greft: string; kemik: string; hacim: string; healing?: string }
  ): number => {
    let total = config.base_fee;
    total += tooth.soket === 'e' ? config.soket_e_fee : config.soket_h_fee;
    total += tooth.greft === 'e' ? config.greft_e_fee : config.greft_h_fee;
    if (tooth.kemik === '1') total += config.kemik_1_fee;
    else if (tooth.kemik === '2') total += config.kemik_2_fee;
    else if (tooth.kemik === '3') total += config.kemik_3_fee;
    total += tooth.hacim === 'z' ? config.hacim_z_fee : config.hacim_y_fee;
    total += (tooth.healing === 'e' ? config.healing_e_fee : config.healing_h_fee) || 0;
    return total;
  },
};
